module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('m-loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "main"
  }, [_c('section', {
    staticClass: "production"
  }, _vm._l((_vm.productions), function(production, index) {
    return _c('section', {
      class: ("item item-" + (index + 1))
    }, [_c('img', {
      staticClass: "logo",
      attrs: {
        "src": _vm.prodctionLogos[index],
        "alt": ""
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_c('span', {
      staticClass: "white"
    }, [_vm._v(_vm._s(production.name))])]), _vm._v(" "), _c('p', {
      staticClass: "price"
    }, [_vm._v("￥" + _vm._s(_vm._f("money")(production.salePrice)))]), _vm._v(" "), _c('p', {
      staticClass: "origin"
    }, [_vm._v("原价￥" + _vm._s(_vm._f("money")(production.originalPrice)))]), _vm._v(" "), _c('a', {
      staticClass: "button button_primary",
      on: {
        "click": function($event) {
          _vm.buyProduction(production)
        }
      }
    }, [_vm._v("\n          立即抢购\n          "), _c('i', {
      staticClass: "icon icon-arrow"
    })])])
  })), _vm._v(" "), _c('section', {
    staticClass: "core"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('section', {
    staticClass: "buy-container"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("即将上线功能")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('section', {
    staticClass: "button-container"
  }, [_c('a', {
    staticClass: "button button_primary",
    on: {
      "click": function($event) {
        _vm.goAnchor()
      }
    }
  }, [_vm._v("\n            立即购买\n          ")])])])]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), (_vm.showDialog) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('section', {
    staticClass: "dialog-warpper"
  }, [_c('section', {
    staticClass: "dialog-overlay",
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "dialog-container"
  }, [_c('a', {
    staticClass: "dialog-close",
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-close"
  })]), _vm._v(" "), _c('section', {
    staticClass: "dialog-header"
  }, [_vm._v("\n          请输入您登录店务通的手机号 "), _c('br'), _vm._v("\n          没有注册过的用户可先购买，购买后用这个 "), _c('br'), _vm._v("\n          手机号注册登录店务通即可\n        ")]), _vm._v(" "), _c('section', {
    staticClass: "dialog-body"
  }, [_c('section', {
    staticClass: "form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tel),
      expression: "tel"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "tel",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": _vm._s(_vm.tel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tel = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "form-ext button_primary",
    class: {
      'is-disabled': _vm.verifyCodeDisabled
    },
    on: {
      "click": function($event) {
        _vm.getVerifyCode()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.verifyCodeText) + "\n            ")])]), _vm._v(" "), _c('section', {
    staticClass: "form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifyCode),
      expression: "verifyCode"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "tel",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": _vm._s(_vm.verifyCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verifyCode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "form-button button_primary",
    class: {
      'is-disabled': _vm.telDisabled, 'is-loading': _vm.submiting
    },
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.telText) + "\n          ")])])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "header"
  }, [_c('img', {
    staticClass: "banner",
    attrs: {
      "src": require("assets/images/banner.jpg"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "border"
  }, [_c('img', {
    staticClass: "butterfly",
    attrs: {
      "src": require("assets/images/butterfly.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "title-container"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n        核心功能\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("\n          一站式解决店铺管理难题\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "function-container flex-container"
  }, [_c('section', {
    staticClass: "flex-item"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/images/function-logo-1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("收银")])]), _vm._v(" "), _c('section', {
    staticClass: "flex-item"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/images/function-logo-2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("会员管理")])]), _vm._v(" "), _c('section', {
    staticClass: "flex-item"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/images/function-logo-3.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("员工业绩")])]), _vm._v(" "), _c('section', {
    staticClass: "flex-item"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/images/function-logo-4.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("经营数据")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "mobile-container"
  }, [_c('img', {
    staticClass: "bg",
    attrs: {
      "src": require("assets/images/bg.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "mobile-row"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/images/mobile-1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/images/mobile-2.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "mobile-row"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/images/mobile-3.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/images/mobile-4.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "function flex-container"
  }, [_c('section', {
    staticClass: "flex-item"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/images/buy-logo-1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("微营销")])]), _vm._v(" "), _c('section', {
    staticClass: "flex-item"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/images/buy-logo-2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("预约")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "footer"
  }, [_c('p', {
    staticClass: "tip"
  }, [_vm._v("还没有下载店务通？")]), _vm._v(" "), _c('p', {
    staticClass: "download"
  }, [_vm._v("AppStore、应用宝等应用商城下载")]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_vm._v("\n        或点击链接\n        "), _c('a', {
    attrs: {
      "href": "//mjb8.cn/00UH"
    }
  }, [_vm._v("\n          http://mjb8.cn/00UH\n        ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-60af2b91!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/Index.vue
// module id = 94
// module chunks = 2